import React from "react";
import { Link } from "react-router-dom";
function ServiceSection() {
  return (
    <div>
      <section className="service-section bg-secondary">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-4 align-items-end">
            <div className="col-12 col-sm-6">
              {/* Section Heading */}
              <div className="section-heading">
                <div className="sub-title">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  Our Services
                </div>
                <h2 className="mb-0">
                  A Passion For Justice, Our Practice Areas
                </h2>
              </div>
            </div>

            <div className="col-12 col-sm-6">
              <div className="text-md-end">
                {/* Button */}
                <Link
                  className="btn btn-primary wow fadeInUp"
                  to="/service"
                  data-wow-duration="1000ms"
                  data-wow-delay="700ms"
                >
                  <span>
                    View All Services <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    View All Services <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="divider-sm"></div>

        <div className="container">
          <div className="swiper service-two-swiper">
            <div className="swiper-wrapper">
              {/* Service Slide */}
              <Link to="/servicedetails" className="swiper-slide">
                <p className="title mb-2">Insurance Law</p>
                <p>
                  Our law firm's securitie there attorneys understand that is a
                  difference.
                </p>
                <img src="assets/img/bg-img/20.jpg" alt="" />
              </Link>

              {/* Service Slide */}
              <Link to="/servicedetails" className="swiper-slide">
                <p className="title mb-2">Family Violence</p>
                <p>
                  Our law firm's securitie there attorneys understand that is a
                  difference.
                </p>
                <img src="assets/img/bg-img/21.jpg" alt="" />
              </Link>

              {/* Service Slide */}
              <Link to="/servicedetails" className="swiper-slide">
                <p className="title mb-2">Health Care Law</p>
                <p>
                  Our law firm's securitie there attorneys understand that is a
                  difference.
                </p>
                <img src="assets/img/bg-img/22.jpg" alt="" />
              </Link>

              {/* Service Slide */}
              <Link to="/servicedetails" className="swiper-slide">
                <p className="title mb-2">Insurance Law</p>
                <p>
                  Our law firm's securitie there attorneys understand that is a
                  difference.
                </p>
                <img src="assets/img/bg-img/20.jpg" alt="" />
              </Link>

              {/* Service Slide */}
              <Link to="/servicedetails" className="swiper-slide">
                <p className="title mb-2">Family Violence</p>
                <p>
                  Our law firm's securitie there attorneys understand that is a
                  difference.
                </p>
                <img src="assets/img/bg-img/21.jpg" alt="" />
              </Link>

              {/* Service Slide */}
              <Link to="/servicedetails" className="swiper-slide">
                <p className="title mb-2">Health Care Law</p>
                <p>
                  Our law firm's securitie there attorneys understand that is a
                  difference.
                </p>
                <img src="assets/img/bg-img/22.jpg" alt="" />
              </Link>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="service-two-pagination"></div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default ServiceSection;
